import React from 'react';
import { motion } from 'framer-motion';
import { Shield, LayoutList, Target, Clock, AlertCircle } from 'lucide-react';
export function Benefits() {
  return <section className="bg-slate-50 py-12 md:py-20 lg:py-24" data-id="element-13">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        {/* Solution Section */}
        <div className="mx-auto max-w-3xl text-center mb-8 md:mb-12" data-id="element-15">
          <h2 className="mb-3 text-2xl text-slate-900 md:text-4xl font-display" data-id="element-16">
            UN SISTEMA QUE TE ORDENA
            <br data-id="element-17" />
            <span className="text-emerald-600" data-id="element-18">
              Y TE DA DIRECCIÓN EN SESIÓN
            </span>
          </h2>
          <p className="text-sm md:text-lg text-slate-600 max-w-2xl mx-auto font-medium" data-id="element-19">
            Todo lo que necesitás para ordenar tu trabajo en un solo lugar.
            Evaluación, planificación, sesiones, seguimiento y reportes listos
            para usar.
          </p>
        </div>

        <div className="grid gap-4 md:gap-8 md:grid-cols-3 max-w-5xl mx-auto" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl bg-white p-6 md:p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-21">
            <div className="mb-4 md:mb-6 inline-flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600" data-id="element-22">
              <Shield className="h-6 w-6 md:h-7 md:w-7" data-id="element-23" />
            </div>
            <h3 className="mb-2 md:mb-3 text-base md:text-xl font-bold text-slate-900 uppercase tracking-tight" data-id="element-24">
              MÁS SEGURIDAD PROFESIONAL
            </h3>
            <p className="text-xs md:text-base text-slate-600 leading-relaxed" data-id="element-25">
              Entrás a cada sesión sabiendo qué observar, cómo conducir el
              encuentro y cómo transformar el problema en un plan de trabajo
              mental.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="rounded-2xl bg-white p-6 md:p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-26">
            <div className="mb-4 md:mb-6 inline-flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-xl bg-blue-50 text-blue-600" data-id="element-27">
              <LayoutList className="h-6 w-6 md:h-7 md:w-7" data-id="element-28" />
            </div>
            <h3 className="mb-2 md:mb-3 text-base md:text-xl font-bold text-slate-900 uppercase tracking-tight" data-id="element-29">
              MÁS ORDEN EN CADA PROCESO
            </h3>
            <p className="text-xs md:text-base text-slate-600 leading-relaxed" data-id="element-30">
              Dejás de depender de "a ver qué trae hoy" y empezás a trabajar con
              evaluación, planificación, intervención y seguimiento.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="rounded-2xl bg-white p-6 md:p-8 border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-31">
            <div className="mb-4 md:mb-6 inline-flex h-12 w-12 md:h-14 md:w-14 items-center justify-center rounded-xl bg-amber-50 text-amber-600" data-id="element-32">
              <Target className="h-6 w-6 md:h-7 md:w-7" data-id="element-33" />
            </div>
            <h3 className="mb-2 md:mb-3 text-base md:text-xl font-bold text-slate-900 uppercase tracking-tight" data-id="element-34">
              ESTRUCTURA REAL
            </h3>
            <p className="text-xs md:text-base text-slate-600 leading-relaxed" data-id="element-35">
              Herramientas, plantillas, guiones y protocolos listos para aplicar
              en sesiones individuales, equipos, lesiones y competencia.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}